import { FpjsProvider } from '@fingerprintjs/fingerprintjs-pro-react';
import React from 'react';

const FingerPrint: React.FC<React.PropsWithChildren> = ({ children }) => {
  const apiKey = import.meta.env.VITE_FINGERPRINT_PUBLIC_API_KEY;

  if (!apiKey) {
    return <>{children}</>;
  }

  return (
    <FpjsProvider
      loadOptions={{
        apiKey,
        region: 'eu',
      }}
    >
      {children}
    </FpjsProvider>
  );
};

export default FingerPrint;
